<template lang="pug">
UiBadge(:variant="variant") {{ label }}
</template>

<script>
const CustomerStatusVariant = {
  failed: "danger",
  processed: "info",
  processing: "success",
  customer_not_found: "info",
};

const CustomerStatusLabelKey = {
  failed: "labels.failed",
  processed: "labels.processed",
  processing: "labels.processing",
  customer_not_found: "labels.customer_not_found",
};

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    variant() {
      return CustomerStatusVariant[this.status] ?? "light";
    },
    label() {
      const labelKey = CustomerStatusLabelKey[this.status] ?? null;
      return labelKey ? this.$t(labelKey) : this.status;
    },
  },
};
</script>
